<template>
    <div class="mt-2 flex items-center text-sm leading-5 text-gray-500">
        <svg
            class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
            fill="currentColor"
            viewBox="0 0 20 20"
        >
            <path
                fill-rule="evenodd"
                d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884zM18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                clip-rule="evenodd"
            />
        </svg>
        <span class="truncate">
            <div class="text-sm leading-5 text-gray-900">
                <a :href="`mailto:${email}`">
                    {{ email }}
                </a>
            </div>
        </span>
    </div>
</template>
<script>
export default {
    props: ["email"]
};
</script>
